import { render, staticRenderFns } from "./app-location-list.vue?vue&type=template&id=f9b275fa&scoped=true&"
import script from "./app-location-list.vue?vue&type=script&lang=ts&"
export * from "./app-location-list.vue?vue&type=script&lang=ts&"
import style1 from "./app-location-list.vue?vue&type=style&index=1&id=f9b275fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b275fa",
  null
  
)

export default component.exports